// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"loaderWrapper--zeXf1","transparent":"transparent--FRoe7"};